import DesignTokens from '@tableau/design-tokens';
import { NotificationInfoOutlineIcon } from '@tableau/icons/NotificationInfoOutlineIcon';
import {
  ButtonProps,
  ButtonType,
  ButtonWidget
} from '@tableau/widgets';
import React from 'react';

import { applyColor } from '~src/style/ColorService';

import { Messages } from '../../../codegen/Localize';
import { SpaceHeaderStyles } from './SpaceHeaderStyles';

const getDetailButtonContent: ButtonProps['getContent'] = (state) => {
  const showActiveIcon = state.hover || state.active || state.focus;
  return (
    <NotificationInfoOutlineIcon
      className={SpaceHeaderStyles.HeaderButtonImage}
      size={18}
      alt=""
      color={showActiveIcon
        ? applyColor(DesignTokens.color.font.default.default, '#333333')
        : applyColor(DesignTokens.color.font.default.secondary, '#666666')}
    />
  );
};

export interface DetailButtonProps {
  readonly testId: string;
}

export function DetailButton(props: DetailButtonProps & React.ButtonHTMLAttributes<HTMLButtonElement>) {
  const { testId, ...buttonProps } = props;
  return (
    <ButtonWidget
      {...buttonProps as ButtonProps}
      buttonType={ButtonType.LowEmphasis}
      getContent={getDetailButtonContent}
      title={Messages.details()}
      testId={`${testId}-detail-button`}
      style={SpaceHeaderStyles.IconButtonStyleOverrides}
    />
  );
}
